import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { JSX, useState } from "react";
import { Action, VoidAction } from "../../util/func";

function YesNoDialog({ opened, title, text, onSubmit }: { opened: boolean; title: string; text: string; onSubmit: Action<boolean> }) {
  return (
    <Dialog open={opened} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography whiteSpace="pre-wrap">{text}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onSubmit(false)}>いいえ</Button>
        <Button onClick={() => onSubmit(true)}>はい</Button>
      </DialogActions>
    </Dialog>
  );
}

export type useYesNoDialogArgs = { title: string; text: string; onConfirm?: VoidAction; onDismiss?: VoidAction };

export function useYesNoDialog(): [JSX.Element, Action<useYesNoDialogArgs>] {
  const [open, setOpen] = useState(false);
  const [args, setArgs] = useState<useYesNoDialogArgs>();

  const dialog = (
    <YesNoDialog
      opened={open}
      title={args?.title ?? ""}
      text={args?.text ?? ""}
      onSubmit={(v) => {
        setOpen(false);
        if (v) {
          args?.onConfirm?.();
        } else {
          args?.onDismiss?.();
        }
      }}
    />
  );
  const show = (args: useYesNoDialogArgs) => {
    setOpen(true);
    setArgs(args);
  };

  return [dialog, show];
}
